import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import { useState } from "preact/hooks"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const [altImg, setAltImg] = useState()
    var prodStyle = product.customFields?.find(v => v.key === 'custom_fields-style')?.value

    if(product.alternateImageUrls && product.alternateImageUrls?.length != 0){
        setAltImg(product.alternateImageUrls[0])
    } else {
        setAltImg(product.imageUrl)
    }

    return (
        <SerpElement
            as="div"
            hit={product}
            class="ns-product grid-item product-item product-item--centered product-item--outer-text product-item--has-quickbuy"
            id={`product-item--template--nosto-${product.productId}`}
        >
            <div class="product-item__image double__image" data-product-image="">
                <a
                class="product-link"
                href={product.url}
                aria-label={prodStyle}
                data-product-link={product.url}
                >
                    <div class="product-item__bg" data-product-image-default="">
                        <figure
                        class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill aos-animate"
                        style="--aspect-ratio: 0.6666666666666666"
                        data-aos="img-in"
                        data-aos-delay="0"
                        data-aos-duration="800"
                        data-aos-anchor={`#product-item--template--nosto-${product.productId}`}
                        data-aos-easing="ease-out-quart"
                        >
                            <img
                                src={(product.imageUrl)?.replace(".jpg", "_900x.jpg")}
                                alt=""
                                width="853"
                                height="1279"
                                loading="eager"
                                srcset={`
                                  ${product.imageUrl.replace(".jpg", "136.jpg")} 136w,
                                  ${product.imageUrl.replace(".jpg", "_160x.jpg")} 160w,
                                  ${product.imageUrl.replace(".jpg", "_220x.jpg")} 220w,
                                  ${product.imageUrl.replace(".jpg", "_320x.jpg")} 320w,
                                  ${product.imageUrl.replace(".jpg", "_480x.jpg")} 480w,
                                  ${product.imageUrl.replace(".jpg", "_528x.jpg")} 528w,
                                  ${product.imageUrl.replace(".jpg", "_640x.jpg")} 640w,
                                  ${product.imageUrl.replace(".jpg", "_720x.jpg")} 720w,
                                  ${product.imageUrl.replace(".jpg", "_900x.jpg")} 900w
                                `}
                                sizes="(min-width: 1400px) calc((100vw - 288px - 100px) / 4 - 32px), (min-width: 750px) calc((100vw - 258px - 64px) / 2 - 32px), (min-width: 480px) calc((100vw - 32px) / 2), calc((100vw - 32px) / 2)"
                                fetchpriority="high"
                                class="fit-cover"
                            />
                        </figure>
                    </div>
                    <deferred-image class="product-item__bg__under">
                        <template>
                            <figure
                              class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill is-loading"
                              style="--aspect-ratio: 0.6666666666666666"
                            >
                                <img
                                    src={altImg?.replace(".jpg", "_900x.jpg")}
                                    alt=""
                                    width="853"
                                    height="1279"
                                    loading="lazy"
                                    srcset={`
                                      ${altImg?.replace(".jpg", "136.jpg")} 136w,
                                      ${altImg?.replace(".jpg", "_160x.jpg")} 160w,
                                      ${altImg?.replace(".jpg", "_220x.jpg")} 220w,
                                      ${altImg?.replace(".jpg", "_320x.jpg")} 320w,
                                      ${altImg?.replace(".jpg", "_480x.jpg")} 480w,
                                      ${altImg?.replace(".jpg", "_528x.jpg")} 528w,
                                      ${altImg?.replace(".jpg", "_640x.jpg")} 640w,
                                      ${altImg?.replace(".jpg", "_720x.jpg")} 720w,
                                      ${altImg?.replace(".jpg", "_900x.jpg")} 900w
                                    `}
                                    sizes="(min-width: 1400px) calc((100vw - 288px - 100px) / 4 - 32px), (min-width: 750px) calc((100vw - 258px - 64px) / 2 - 32px), (min-width: 480px) calc((100vw - 32px) / 2), calc((100vw - 32px) / 2)"
                                    class="fit-cover is-loading"
                                />
                            </figure>
                        </template>
                        <figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill" style="--aspect-ratio: 0.6666666666666666">
                            <img
                                src={altImg}
                                alt=""
                                width="853"
                                height="1279"
                                loading="lazy"
                                srcset={`
                                    ${altImg}&amp;width=136 136w,
                                    ${altImg}&amp;width=160 160w,
                                    ${altImg}&amp;width=180 180w,
                                    ${altImg}&amp;width=220 220w,
                                    ${altImg}&amp;width=254 254w,
                                    ${altImg}&amp;width=284 284w,
                                    ${altImg}&amp;width=292 292w,
                                    ${altImg}&amp;width=320 320w,
                                    ${altImg}&amp;width=480 480w,
                                    ${altImg}&amp;width=528 528w,
                                    ${altImg}&amp;width=640 640w,
                                    ${altImg}&amp;width=720 720w,
                                    ${altImg}&amp;width=853 853w
                                `}
                                sizes="(min-width: 1400px) calc((100vw - 288px - 100px) / 4 - 32px), (min-width: 750px) calc((100vw - 258px - 64px) / 2 - 32px), (min-width: 480px) calc((100vw - 32px) / 2), calc((100vw - 32px) / 2)"
                                class="fit-cover"
                            />
                        </figure>
                    </deferred-image>
                </a>
                
                {/* <quick-add-product>
                    <div class="quick-add__holder" data-quick-add-holder={product.productId}>
                        <button
                            class="quick-add__button caps"
                            type="button"
                            aria-label="Quick add"
                            data-quick-add-btn=""
                            data-quick-add-modal-handle={product.url.toString().split("/products/")[1]}
                        >
                            <span class="btn__text">Quick add</span>
                            <span class="btn__plus"></span>
                            <span class="btn__added">&nbsp;</span>
                            <span class="btn__loader">
                                <svg height="18" width="18" class="svg-loader">
                                    <circle r="7" cx="9" cy="9"></circle>
                                    <circle stroke-dasharray="87.96459430051421 87.96459430051421"r="7"cx="9"cy="9"></circle>
                                </svg>
                            </span>
                        </button>

                        <template data-quick-add-modal-template="">
                            <dialog 
                                class="product-quick-add"
                                data-product-id={product.productId}
                                data-section-id={`template--nosto-${product.productId}`}
                                inert=""
                                data-quick-add-modal=""
                                data-scroll-lock-required=""
                            >
                                <form method="dialog">
                                    <button class="visually-hidden no-js" aria-label="Close"></button>
                                </form>

                                <div
                                  class="product-quick-add__content"
                                  data-product-upsell-container=""
                                  data-scroll-lock-scrollable=""
                                  style="--swatch-size: var(--swatch-size-product)"
                                >
                                    <div class="product-quick-add__close-outer">
                                        <button
                                            class="product-quick-add__close drawer__close"
                                            aria-label="Close"
                                            data-quick-add-modal-close=""
                                            autofocus=""
                                        >
                                            <svg
                                                aria-hidden="true"
                                                focusable="false"
                                                role="presentation"
                                                class="icon icon-cancel"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>
                                    <div class="product-quick-add__inner" data-product-upsell-ajax=""></div>
                                    <div class="loader loader--top">
                                        <div class="loader-indeterminate"></div>
                                    </div>
                                </div>
                            </dialog>
                        </template>
                    </div>
                </quick-add-product> */}
            </div>

            <div class="product-information" data-product-information="">
                <div class="product-item__info">
                    <a class="product-link" href={product.url} data-product-link={product.url}>
                        <p class="product-item__title">{prodStyle}</p>

                        <div class="product-item__price__holder">
                            <div class="product-item__price" data-product-price="">
                                <span class={`price ${product.onDiscount ? 'sale' : ''}`}>
                                    <span class="new-price">{format(product.price)}</span>
                                    {product.onDiscount && <span class="old-price">{format(product.listPrice)}</span>}
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

        </SerpElement>
    )
}
